import React from "react";
import {
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
  Area,
  AreaChart,
} from "recharts";

interface BarChartComponentProps {
  data: {
    year: string;
    monthName: string;
    monthNumber: number;
    signupFemales: number;
    signupMales: number;
  }[];
}

const allMonths = [
  { monthName: "Jan", monthNumber: 1 },
  { monthName: "Feb", monthNumber: 2 },
  { monthName: "Mar", monthNumber: 3 },
  { monthName: "Apr", monthNumber: 4 },
  { monthName: "May", monthNumber: 5 },
  { monthName: "Jun", monthNumber: 6 },
  { monthName: "Jul", monthNumber: 7 },
  { monthName: "Aug", monthNumber: 8 },
  { monthName: "Sep", monthNumber: 9 },
  { monthName: "Oct", monthNumber: 10 },
  { monthName: "Nov", monthNumber: 11 },
  { monthName: "Dec", monthNumber: 12 },
];

const LineChartComponent: React.FC<BarChartComponentProps> = ({ data }) => {
  const mergedData = allMonths.map((month) => {
    const monthData = data.find((d) => d.monthNumber === month.monthNumber);
    return monthData
      ? monthData
      : { ...month, signupFemales: 0, signupMales: 0 };
  });

  return (
    <ResponsiveContainer width="100%" height="125%">
      <AreaChart data={mergedData}>
        <CartesianGrid strokeDasharray="3 3" vertical={false} />
        <XAxis dataKey="monthName" />
        <YAxis />
        <Tooltip />
        <Area
          type="monotone"
          dataKey="signupFemales"
          stroke="#f36538"
          fill="#c992ea"
          strokeWidth={3}
          name="Females"
        />
        <Area
          type="monotone"
          dataKey="signupMales"
          stroke="#7600bc"
          fill="#c992ea"
          strokeWidth={3}
          name="Males"
        />
        <Area
          type="monotone"
          dataKey="signupOther"
          stroke="#000"
          fill="#c992ea"
          strokeWidth={3}
          name="Others"
        />
      </AreaChart>
    </ResponsiveContainer>
  );
};

export default LineChartComponent;
